'use strict';

var AppDispatcher = require('../AppDispatcher'),
    ActionTypes = require('../constants/ActionTypes');

var ScreenSizeActionCreators = {
  handleWindowResize() {
    AppDispatcher.handleViewAction({
      type: ActionTypes.RESIZE_WINDOW
    });
  }
};

module.exports = ScreenSizeActionCreators;


/** WEBPACK FOOTER **
 ** ./actions/ScreenSizeActionCreators.js
 **/